// import React from 'react';
// import { Link } from 'react-router-dom';
// import './ProspectusPage.css';
// import Navbar from './Navbar';
// import FooterSection from './FooterSection';

// export default function ProspectusPage() {
//   const prospectusContents = [
//     'University Overview & History',
//     'CDOE Introduction',
//     'Programs Offered (UG / PG / Diploma)',
//     'Eligibility Criteria',
//     'Fee Structure 2025–26',
//     'Important Dates',
//     'Admission Procedure',
//     'Study Centre Directory',
//     'Rules & Regulations',
//     'Examination Guidelines',
//     'Contact Directory'
//   ];

//   const keyDates = [
//     { label: 'Applications Open', value: 'July 5, 2025', isHighlight: false },
//     { label: 'Last Date (Normal)', value: 'Sep 30, 2025', isHighlight: true },
//     { label: 'Late Fee Period', value: 'Oct 1 – 31, 2025', isHighlight: false },
//     { label: 'Classes Begin', value: 'Nov/Dec 2025', isHighlight: false }
//   ];

//   const relatedDownloads = [
//     { title: 'Application Form', size: '1.1 MB' },
//     { title: 'Fee Structure PDF', size: '420 KB' }
//   ];

//   return (
//         <>
//          <Navbar />
//     <div className="prospectus-page-wrapper">
      
//       {/* 1. Top Blue Header Banner */}
//       <section className="prospectus-hero-banner">
//         <div className="banner-inner-container">
//           <div className="banner-left-content">
//             <nav className="breadcrumb-nav">
//               <Link to="/" className="breadcrumb-link">Home</Link> / <span>Prospectus</span>
//             </nav>
//             <h1>Prospectus 2025–26</h1>
//             <p className="subtitle-brand">
//               Centre for Distance and Online Education, EDULEARNER
//             </p>
//             <p className="subtitle-session">
//               Academic Year 2025–26 | July Session Admission
//             </p>
//           </div>

//           <div className="banner-right-content">
//             <a href="#download-pdf" className="btn-top-download">
//               <span className="dl-icon">📥</span> Download Prospectus PDF
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* 2. Main Page Body (Viewer Mockup & Side Cards Grid) */}
//       <section className="prospectus-main-section">
//         <div className="prospectus-container grid-layout-2col">
          
//           {/* Left Side: PDF Document Viewer Card Shell */}
//           <div className="pdf-viewer-card">
//             {/* Dark Top Action Bar */}
//             <div className="pdf-header-bar">
//               <div className="pdf-file-info">
//                 <span className="file-icon">📄</span>
//                 <span className="file-name">Prospectus_CDOE_2025-26.pdf</span>
//               </div>
//               <button className="btn-pdf-top-dl">
//                 <span className="dl-mini-icon">📥</span> Download
//               </button>
//             </div>

//             {/* Inner Document Canvas Placeholder */}
//             <div className="pdf-canvas-body">
//               <div className="pdf-document-icon">📄</div>
//               <h2>CDOE Prospectus AY 2025–26</h2>
//               <p>EDULEARNER | July Session</p>
              
//               <button className="btn-full-prospectus-dl">
//                 <span className="dl-mini-icon">📥</span> Download Full Prospectus (4.2 MB)
//               </button>
//             </div>
//           </div>

//           {/* Right Side: Sidebar Meta Cards */}
//           <div className="prospectus-sidebar">
            
//             {/* Card 1: Prospectus Contents List */}
//             <div className="sidebar-card">
//               <h3 className="sidebar-title">Prospectus Contents</h3>
//               <ul className="contents-checklist">
//                 {prospectusContents.map((item, index) => (
//                   <li key={index} className="checklist-item">
//                     <span className="check-icon">✓</span>
//                     <span>{item}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* Card 2: Key Admission Dates (Dark Blue Panel) */}
//             <div className="sidebar-card dark-blue-panel">
//               <div className="panel-title-row">
//                 <span className="panel-icon">📅</span>
//                 <h3>Key Admission Dates</h3>
//               </div>
//               <div className="key-dates-list">
//                 {keyDates.map((item, index) => (
//                   <div key={index} className="key-date-row">
//                     <span className="date-label">{item.label}</span>
//                     <span className={`date-val ${item.isHighlight ? 'highlight-gold' : ''}`}>
//                       {item.value}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* Card 3: Related Downloads */}
//             <div className="sidebar-card">
//               <div className="panel-title-row">
//                 <span className="panel-icon">📖</span>
//                 <h3 className="sidebar-title1" style={{color:"#0A2540"}}>Related Downloads</h3>
//               </div>
//               <div className="related-downloads-list">
//                 {relatedDownloads.map((doc, index) => (
//                   <div key={index} className="download-row-item">
//                     <div className="doc-info-left">
//                       <span className="doc-icon">📄</span>
//                       <span className="doc-title">{doc.title}</span>
//                     </div>
//                     <span className="doc-size">{doc.size}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>

//           </div>

//         </div>
//       </section>

//     </div>
//      <FooterSection/>
//             </>
//   );
// }


import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ProspectusPage.css';
import Navbar from './Navbar';
import FooterSection from './FooterSection';

export default function ProspectusPage() {
  const [prospectus, setProspectus] = useState(null);
  const [keyDates, setKeyDates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProspectusAndDates();
  }, []);

  const fetchProspectusAndDates = async () => {
    try {
      setLoading(true);
      // 1. Fetch Dynamic Prospectus Document
      const resProspectus = await fetch('https://metapi.emedhatechnologies.com/api/prospectus');
      const jsonProspectus = await resProspectus.json();
      if (jsonProspectus.success && jsonProspectus.data.length > 0) {
        setProspectus(jsonProspectus.data[0]); // Load primary active prospectus
      }

      // 2. Fetch Dynamic Key Admission Dates
      const resDates = await fetch('https://metapi.emedhatechnologies.com/api/admission-dates');
      const jsonDates = await resDates.json();
      if (jsonDates.success) {
        setKeyDates(jsonDates.data || []);
      }
    } catch (err) {
      console.error("Failed to load prospectus details:", err);
    } finally {
      setLoading(false);
    }
  };

  // Helper to trigger clean download or view in a new tab
  const handleDownloadPdf = () => {
    if (prospectus?.pdf_file_url) {
      window.open(prospectus.pdf_file_url, '_blank', 'noopener,noreferrer');
    } else {
      alert("Prospectus PDF is currently being updated. Please try again shortly.");
    }
  };

  const checklistItems = Array.isArray(prospectus?.contents_checklist) 
    ? prospectus.contents_checklist 
    : [
        'University Overview & History',
        'CDOE Introduction',
        'Programs Offered (UG / PG / Diploma)',
        'Eligibility Criteria',
        'Fee Structure 2026–27',
        'Important Dates',
        'Admission Procedure',
        'Study Centre Directory'
      ];

  return (
    <>
      <Navbar />
      <div className="prospectus-page-wrapper">
        
        {/* 1. Top Header Banner */}
        <section className="prospectus-hero-banner">
          <div className="banner-inner-container">
            <div className="banner-left-content">
              <nav className="breadcrumb-nav">
                <Link to="/" className="breadcrumb-link">Home</Link> / <span>Prospectus</span>
              </nav>
              <h1>{prospectus?.title || 'Prospectus 2026–27'}</h1>
              <p className="subtitle-brand">
                Centre for Distance and Online Education, Edulearner
              </p>
              <p className="subtitle-session">
                Academic Year {prospectus?.academic_year || 'AY 2026–27'} | {prospectus?.session_subtitle || 'August Session Admission'}
              </p>
            </div>

            <div className="banner-right-content">
              <button onClick={handleDownloadPdf} className="btn-top-download" style={{ cursor: 'pointer', border: 'none' }}>
                <span className="dl-icon">📥</span> Download Prospectus PDF
              </button>
            </div>
          </div>
        </section>

        {/* 2. Main Page Body (Viewer Card & Side Cards Grid) */}
        <section className="prospectus-main-section">
          <div className="prospectus-container grid-layout-2col">
            
            {/* Left Side: PDF Document Card */}
            <div className="pdf-viewer-card">
              {/* Dark Top Action Bar */}
              <div className="pdf-header-bar">
                <div className="pdf-file-info">
                  <span className="file-icon">📄</span>
                  <span className="file-name">
                    {prospectus?.file_name || 'Prospectus_CDOE_2026-27.pdf'}
                  </span>
                </div>
                <button onClick={handleDownloadPdf} className="btn-pdf-top-dl" style={{ cursor: 'pointer', border: 'none' }}>
                  <span className="dl-mini-icon">📥</span> Download
                </button>
              </div>

              {/* Inner Document Canvas */}
              <div className="pdf-canvas-body">
                <div className="pdf-document-icon">📄</div>
                <h2>{prospectus?.title || 'CDOE Prospectus AY 2026–27'}</h2>
                <p>{prospectus?.session_subtitle || 'Edulearner | August Session'}</p>
                
                <button 
                  onClick={handleDownloadPdf} 
                  className="btn-full-prospectus-dl" 
                  style={{ cursor: 'pointer', border: 'none' }}
                >
                  <span className="dl-mini-icon">📥</span> Download Full Prospectus ({prospectus?.file_size_text || '243.8 KB'})
                </button>
              </div>
            </div>

            {/* Right Side: Sidebar Cards */}
            <div className="prospectus-sidebar">
              
              {/* Card 1: Dynamic Prospectus Contents List */}
              <div className="sidebar-card">
                <h3 className="sidebar-title">Prospectus Contents</h3>
                <ul className="contents-checklist">
                  {checklistItems.map((item, index) => (
                    <li key={index} className="checklist-item">
                      <span className="check-icon">✓</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Card 2: Dynamic Key Admission Dates */}
              <div className="sidebar-card dark-blue-panel">
                <div className="panel-title-row">
                  <span className="panel-icon">📅</span>
                  <h3>Key Admission Dates</h3>
                </div>
                <div className="key-dates-list">
                  {keyDates.length === 0 ? (
                    <div style={{ color: '#94a3b8', fontSize: '13px', padding: '8px 0' }}>
                      Loading academic calendar...
                    </div>
                  ) : (
                    keyDates.map((item) => (
                      <div key={item.id} className="key-date-row">
                        <div>
                          <span className="date-label">{item.event_title}</span>
                          {item.badge_note && (
                            <span style={{ display: 'block', fontSize: '10px', color: '#fca5a5', fontWeight: '700', textTransform: 'uppercase' }}>
                              {item.badge_note}
                            </span>
                          )}
                        </div>
                        <span className={`date-val ${Number(item.is_highlighted) === 1 ? 'highlight-gold' : ''}`}>
                          {item.event_date}
                        </span>
                      </div>
                    ))
                  )}
                </div>
              </div>

            </div>

          </div>
        </section>

      </div>
      <FooterSection />
    </>
  );
}